<template>
  <div id="app" :class="{'app-max-width': $route.name !== 'Login'}">
    
    <transition name="component-fade" mode="out-in">
      <router-view />
    </transition>
    <rodape-usuario v-if="exibirRodape"/>
  </div>
</template>

<script>
import RodapeUsuario from '@/components/RodapeUsuario.vue';

export default {
  components: {RodapeUsuario},
  mounted() {
    // Inicialização do Modo Escuro
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      document.body.classList.add('dark-theme');
    }
  },
  computed: {
    exibirRodape() {
      return !['Login', 'Acesso Negado'].includes(this.$route.name);
    }
  }
};
</script>

<style>
html, body {
  overflow-x: hidden !important;
  width: 100%;
  min-height: 100vh;
  background-color: #f4f6f9; 
}

body.modal-open {
  padding-right: 0 !important;
  overflow: visible !important;
}
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow-x: hidden !important;
}

.app-max-width {
  max-width: 1400px;
  margin: 0 auto;
}

#nav {
  padding: 0px;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #303f9f;
}

.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
